import { stripToDigits } from 'shared/utils/phoneUtils/phoneUtils'
import { Input } from 'components/forms'
import { useEffect } from 'react'
import { PhoneIcon } from './PhoneIcon'
import css from './OptInPhoneNumberDisplay.styles.scss'
import { formatPhoneDisplay } from '../../../../shared/utils/phoneUtils/phoneUtils'
import { SmsOptInDisclaimerCopy } from './SmsOptInDisclaimerCopy'

interface OptInPhoneNumberDisclaimerProps {
  phoneNumber?: string
  userPhone?: {
    value: string
    error: string
    touched: boolean
    onChange: (value: string) => void
    onBlur?: () => void
  }
  consentedToSmsCheckbox?: {
    value: boolean
  }
}

export const OptInPhoneNumberDisclaimer: React.FC<
  OptInPhoneNumberDisclaimerProps
> = ({ phoneNumber, consentedToSmsCheckbox, userPhone }) => {
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const inputValue = e.target.value

      if (!inputValue) {
        userPhone?.onChange('')
        // Force field to be marked as touched when empty and checkbox enabled
        if (consentedToSmsCheckbox?.value && userPhone?.onBlur) {
          userPhone.onBlur()
        }
        return
      }

      const digitsOnly = stripToDigits(inputValue)

      if (digitsOnly.length <= 10) {
        const formatted = formatPhoneDisplay(digitsOnly)
        userPhone?.onChange(formatted)
      }

      // Force validation check when checkbox is enabled
      if (consentedToSmsCheckbox?.value && userPhone?.onBlur) {
        userPhone.onBlur()
      }
    } catch (err) {
      console.error('Phone formatting error:', err)
      userPhone?.onChange(e.target.value)
    }
  }

  const updatePhoneNumber = (phone: string) => {
    if (phone && userPhone?.onChange && !userPhone.value) {
      userPhone.onChange(formatPhoneDisplay(phone))
    }
  }

  const handleSmsConsent = () => {
    if (consentedToSmsCheckbox?.value && userPhone?.onBlur) {
      userPhone.onBlur()
    }
  }

  // If user phone number is present, pre-fill the phone number input with it
  // If shipping address phone number is present and user phone is blank, pre-fill the address phone number input with it
  useEffect(() => {
    if (phoneNumber) {
      updatePhoneNumber(phoneNumber)
    }
    handleSmsConsent()
  }, [consentedToSmsCheckbox?.value])

  return (
    <div className={css.disclaimerContainer}>
      <div className={css.disclaimerWrapper}>
        <div className={css.phoneInputWrapper}>
          <div className={css.phoneInputIcon}>
            <PhoneIcon />
          </div>

          <Input
            className={css.phoneInput}
            {...userPhone}
            error={
              (userPhone?.touched ||
                (consentedToSmsCheckbox?.value && userPhone?.value)) &&
              userPhone?.error
                ? userPhone.error
                : null
            }
            id="phone"
            maxLength="14"
            type="tel"
            onChange={handlePhoneChange}
          />
        </div>

        <span className={`small text-muted ${css.disclaimerTextCopyContainer}`}>
          <SmsOptInDisclaimerCopy />
        </span>
      </div>
    </div>
  )
}
